/**
 * Hook to check if a product is eligible for approval request
 */
import useSWR from "swr";
import { endpoints } from "../../../../../endpoints";
import type { ProductApprovalEligibility } from "../../../../../types/types.Workflow";
import { useStoreState } from "../../../../../util/util";

export function useApprovalEligibility(productId: string | null) {
  const { storefront_id } = useStoreState();
  const {
    storefront_metadata: { enable_approval_workflow },
  } = useStoreState();
  const { data, error, mutate, isValidating } =
    useSWR<ProductApprovalEligibility>(
      storefront_id && productId && enable_approval_workflow
        ? endpoints.v2_storefronts_id_integrations_products_id_approvals_eligibility(
            storefront_id,
            productId
          )
        : null
    );

  return {
    eligible: data?.eligible ?? false,
    blockedReasons: data?.eligibility_blocks ?? [],
    enabled: data?.enabled ?? false,
    uiRules: data?.ui_rules ?? [],
    error,
    isLoading: !data && !error && !!productId,
    isValidating,
    mutate,
  };
}
